__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@carbon/ibm-products", "1.34.0", () => (() => (__webpack_require__(23201))), 1);
			register("@carbon/layout", "10.37.1", () => (() => (__webpack_require__(76657))), 1);
			register("@carbon/layout", "10.37.5", () => (() => (__webpack_require__(39824))), 1);
			register("carbon-components-react", "7.59.3", () => (() => (__webpack_require__(66333))), 1);
			register("carbon-components-react", "7.60.5", () => (() => (__webpack_require__(87697))), 1);
			register("carbon-components", "10.58.3", () => (() => (__webpack_require__(29851))), 1);
			register("carbon-components", "10.59.2", () => (() => (__webpack_require__(10938))), 1);
			register("i18next-http-backend", "1.3.2", () => (() => (__webpack_require__(23717))), 1);
			register("i18next", "21.6.11", () => (() => (__webpack_require__(44978))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(97950))), 1);
			register("react-i18next", "11.15.5", () => (() => (__webpack_require__(22264))), 1);
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(53245))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(65043))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};